{
  "help": "Hilfe",
  "info": "Informationen"
}
